import createSentry from "@services/create-sentry"
import Vue from "vue"

import { practiceModules } from "./shared/state/index"
import mixins from "~mixins"
import PracticeView from "./views/Practice/PracticeView"
import "~taiwind"
import notifier from "@components/Notifications/notifier"
import VueScreenSize from "vue-screen-size"

import "@components/Practice/PracticeQuestions/components/global.js"
import PracticeContainer from "./views/Practice/components/PracticeContent/PracticeContainer.vue"
import Vuex from "vuex"
import cloneDeep from "lodash.clonedeep"

Vue.use(VueScreenSize)

let token = localStorage.getItem("token")
if (!token || token !== window.token) token = window.token
let {
    practice,
    customStyle = "null",
    isAuth = "false",
    isPreEntry = "false",
    isFreeCourse = "false"
} = document.querySelector("#practice")
    ? document.querySelector("#practice").dataset
    : { practice: null, isAuth: "false", isPreEntry: "false", isFreeCourse: "false", customStyle: "null" }

Vue.prototype.$notify = notifier.exec
Vue.mixin({
    computed: {
        $screenWidth() {
            return this.$vssWidth
        },
        $screenHeight() {
            return this.$vssHeight
        }
    },
    methods: {
        $hasAttr(attr) {
            if (this.$attrs.hasOwnProperty(attr)) {
                if (this.$attrs[attr] === "") {
                    return attr
                } else if (typeof this.$attrs[attr] === "boolean") {
                    if (!this.$attrs[attr]) {
                        return ""
                    } else {
                        return attr
                    }
                }
            }
            return ""
        }
    }
})

const _practice = JSON.parse(practice) || {}
const _customStyle = JSON.parse(customStyle)
const _isAuth = JSON.parse(isAuth)

_practice["isPreEntry"] = JSON.parse(isPreEntry)
_practice["isFreeCourse"] = JSON.parse(isFreeCourse)

Object.defineProperty(String.prototype, "capitalize", {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1)
    },
    enumerable: false,
    configurable: true
})

if (document.querySelector("#practice")) {
    Vue.mixin(mixins)

    const store = new Vuex.Store({
        modules: practiceModules
    })

    let forUser = []
    if (_isAuth) {
        forUser = [store.dispatch("user/fetchUser"), store.dispatch("user/fetchCabinets")]
    }
    Promise.all([...forUser, store.dispatch("user/fetchIsProductionMode"), store.dispatch("langs/fetchLangs")]).then(
        ([user]) => {
            new Vue({
                el: "#practice",
                store,
                render: h =>
                    h(PracticeView, {
                        props: {
                            _customStyle,
                            _practice,
                            _isAuth
                        }
                    })
            })

            createSentry(Vue, null, user)
        }
    )
} else {
    const store = new Vuex.Store({
        modules: practiceModules
    })

    Vue.mixin(mixins)

    Promise.all([
        store.dispatch("user/fetchCabinets"),
        store.dispatch("user/fetchUser"),
        store.dispatch("user/fetchIsProductionMode"),
        store.dispatch("langs/fetchLangs")
    ]).then(() => {
        setTimeout(() => {
            document.querySelectorAll(`[data-practice-container]`).forEach(el => {
                const { practiceContainer: quizId, lessonId, courseId, unitId } = el.dataset

                new Vue({
                    el: `[data-practice-container="${quizId}"]`,
                    store: new Vuex.Store({
                        modules: cloneDeep(practiceModules)
                    }),
                    render: h =>
                        h(PracticeContainer, {
                            props: {
                                quizId: parseInt(quizId),
                                lessonId: parseInt(lessonId),
                                unitId: parseInt(unitId),
                                courseId: parseInt(courseId)
                            }
                        })
                })
            })
        }, 2000)
    })
}
